import { useBreadcrumb } from "features/breadcrumbs";
import { useLoading } from "components/GlobalLoading";
import { Text } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import { useParams } from "react-router";
import Mensagem from "./components/Mensagem";
import useDetalheMensagem from "features/mensagens/hooks/useDetalheMensagem";
import backgroundMensagens from "assets/images/background-mensagens.svg";
import colors from "core/resources/theme/colors";
import history from "infra/helpers/history";
import moment from "moment";
import PageHeader from "components/Page/PageHeader";
import { Col, Row } from "antd";
import CardDefault from "components/Cards/CardDefault";
import { useMemo, useEffect } from "react";
import { MensagemOrigem } from "features/mensagens/typings";
import useLerMensagem from "features/mensagens/hooks/useLerMensagem";
import Container from "components/Container";
import OutlineButton from "ui/components/Button/OutlineButton";

function HistoricoMensagemPage() {
  const { mutate: lerMensagem } = useLerMensagem();
  const { id } = useParams() as { id: string };
  const {
    data: mensagem,
    isLoading: isLoadingDetalhe,
    refetch: refetchDetalhe,
    isFetching,
  } = useDetalheMensagem(id);

  const _isLoading = isLoadingDetalhe;

  useLoading(_isLoading);

  useEffect(() => {
    if (mensagem && id) {
      lerMensagem(id);
    }
  }, [mensagem, lerMensagem, id]);

  useBreadcrumb([
    { name: "Administração" },
    { name: "Mensagens", url: "/administracao/mensagens" },
    {
      name: mensagem ? mensagem.assunto : id,
    },
  ]);

  const titulo = useMemo(() => {
    if (!mensagem) {
      return "Detalhes";
    }

    return (
      <>
        {mensagem.assunto} - {moment(mensagem.createdAt).format("DD/MM/YYYY")}{" "}
      </>
    );
  }, [mensagem]);

  return (
    <Container pb="32px">
      <Box as={Row} gutter={32}>
        <Box as={Col} xs={18}>
          <PageHeader title={titulo} />
        </Box>

        <Box as={Col} xs={6}>
          <Flex
            mt={"-30px"}
            zIndex={-99}
            flex={1}
            w={"100%"}
            h={"160px"}
            ml="auto"
            bgImage={backgroundMensagens}
            bgRepeat="no-repeat"
            bgSize="cover"
          />
        </Box>
      </Box>
      <Flex flexDir="column" minH="50px">
        <CardDefault>
          {mensagem ? (
            <>
              <Flex mb={6} alignItems="center">
                <OutlineButton cursor="pointer" onClick={history.goBack} mr={4}>
                  Voltar
                </OutlineButton>
                <Text
                  fontSize={14}
                  color={colors.primary}
                  ml="auto"
                  fontWeight="medium"
                  mt={0}
                >
                  {mensagem.numRespostas || 0}{" "}
                  {mensagem.numRespostas === 1 ? "resposta" : "respostas"}
                </Text>
              </Flex>
              <Mensagem
                mensagemId={mensagem.id}
                showResponder={mensagem.origem === MensagemOrigem.Recebida}
                showLeituras={
                  !!mensagem.numDestinos &&
                  mensagem.numDestinos > 0 &&
                  mensagem.origem !== MensagemOrigem.Excluida
                }
                data={mensagem.createdAt}
                nome={`${mensagem.autor}`}
                unidade={mensagem.unidade}
                anexos={mensagem.anexos}
                conteudo={mensagem.conteudo}
                imagemUrl={mensagem.imagemUrl}
                numRespostas={mensagem.numRespostas}
                defaultOpenRespostas={true}
                defaultCollapsed={false}
                refetchPai={refetchDetalhe}
                isRefetchingPai={isFetching && !isLoadingDetalhe}
                numDestinos={mensagem.numDestinos}
                numDestinosLidos={mensagem.numDestinosLidos}
                origem={mensagem.origem}
              />
            </>
          ) : null}
        </CardDefault>
      </Flex>
    </Container>
  );
}

export default HistoricoMensagemPage;
